import React from "react";
import { motion } from "framer-motion";
import Reveal from "../../Reveal";
import { useI18n } from "../../../i18n/LanguageContext";
import { SITE } from "../../../content/site";

const NUMS = ["01", "02", "03", "04", "05"];

export default function CreationStrategy() {
  const { lang } = useI18n();
  const c = (SITE[lang].homeStory || SITE.en.homeStory).creation;
  return (
    <section data-testid="home-creation" className="bg-[#f6f5f2] px-6 py-28 md:px-12 md:py-40">
      <div className="mx-auto grid max-w-[1400px] gap-16 lg:grid-cols-12 lg:gap-10">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Reveal><p className="overline text-[#0e7c6b]">{c.overline}</p></Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display mt-7 text-3xl font-light leading-[1.05] tracking-tightest text-[#050505] md:text-5xl">{c.title}</h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-7 max-w-lg text-base font-light leading-relaxed text-[#4a4a4a] md:text-lg">{c.text}</p>
            </Reveal>
            <Reveal delay={0.3}>
              <p className="mt-9 max-w-lg border-l-2 border-[#0e7c6b] pl-5 text-base font-light leading-relaxed text-[#2a2b29]">{c.note}</p>
            </Reveal>
          </div>
        </div>

        {/* Blueprint sequence */}
        <div className="relative lg:col-span-6 lg:col-start-7">
          <motion.span
            initial={{ scaleY: 0 }} whileInView={{ scaleY: 1 }} viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
            className="absolute left-[11px] top-3 bottom-10 w-px origin-top bg-[#c9c5bc]"
          />
          <div className="space-y-12 md:space-y-16">
            {c.stages.map((s, i) => (
              <Reveal key={s.k} delay={0.12 * i} className="relative pl-12 md:pl-16">
                <span className="absolute left-0 top-1.5 flex h-[23px] w-[23px] items-center justify-center rounded-full border border-[#0e7c6b] bg-[#f6f5f2]">
                  <span className="h-[7px] w-[7px] rounded-full bg-[#0e7c6b]" />
                </span>
                <div data-testid={`creation-stage-${i}`}>
                  <p className="font-display text-sm font-500 tracking-[0.25em] text-[#9a9d98]">{NUMS[i]}</p>
                  <h3 className="font-display mt-2 text-2xl font-light tracking-tight text-[#050505] md:text-3xl">{s.k}</h3>
                  <p className="mt-3 max-w-lg text-base font-light leading-relaxed text-[#6b6f6c]">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
